module.exports = __webpack_public_path__ + "fonts/motiva-sans-regular.243426c.otf";